// Deterministic RNG (xorshift32) + coordinate hashing

/**
 * Create a seeded xorshift32 PRNG.
 * @param {number} seed - 32-bit integer seed (must be non-zero)
 * @returns {{ next: () => number, nextFloat: () => number }}
 */
export function createRng(seed) {
  let state = seed | 0;
  if (state === 0) state = 1;

  function next() {
    state ^= state << 13;
    state ^= state >> 17;
    state ^= state << 5;
    return state;
  }

  function nextFloat() {
    return (next() >>> 0) / 0x100000000;
  }

  return { next, nextFloat };
}

/**
 * Hash two integers into a seed value.
 */
export function hashCoords(x, y, worldSeed) {
  let h = worldSeed | 0;
  h = (h ^ (x * 374761393)) | 0;
  h = (h ^ (y * 668265263)) | 0;
  h = Math.imul(h ^ (h >>> 13), 1274126177);
  h = h ^ (h >>> 16);
  return h === 0 ? 1 : h;
}
